module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"cancel":"Cancel","proceed":"Proceed"}}')
  delete Component.options._Ctor
}
